/* eslint-disable */
import { useEffect, useState } from "react";

// Heat grid view settings, shared by every screen that shows or sets them (kept in localStorage; all copies stay in sync via the "heatGridChange" event).
const EVENT = "heatGridChange";
const KEYS = { on: "heatGridOn", all: "heatGridAll", opacity: "heatGridOpacity" };
const DEFAULTS = { on: false, all: false, opacity: 50 };

// junk in localStorage must never reach the screens: on/all only true when exactly true; opacity a number 0-100 (else 50)
const clean = (name, v) => {
  if (name === "opacity") { const n = Number(v); return Number.isFinite(n) && v !== null && v !== "" ? Math.max(0, Math.min(100, n)) : DEFAULTS.opacity; }
  return v === true;
};
const read = () => Object.fromEntries(Object.entries(KEYS).map(([name, key]) => {
  try { return [name, clean(name, JSON.parse(localStorage.getItem(key)))]; } catch (e) { return [name, DEFAULTS[name]]; }
}));

// const [{ on, all, opacity }, set] = useHeatGrid();  set("on", true)
const useHeatGrid = () => {
  const [settings, setSettings] = useState(read);
  useEffect(() => {
    const sync = () => setSettings(read());
    window.addEventListener(EVENT, sync);
    return () => window.removeEventListener(EVENT, sync);
  }, []);
  const set = (name, value) => {
    try { localStorage.setItem(KEYS[name], JSON.stringify(value)); } catch (e) {}
    setSettings(read());
    window.dispatchEvent(new Event(EVENT));
  };
  return [settings, set];
};

export default useHeatGrid;
